import type { FC, ReactNode } from "react";
import MenuRounded from "@mui/icons-material/MenuRounded";
import { AppBar, IconButton, Stack, Toolbar } from "@mui/material";

export interface HeaderProps {
  onMenuToggle: () => void;
  accountMenu?: ReactNode;
}

export const Header: FC<HeaderProps> = ({ onMenuToggle, accountMenu }) => {
  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={({ palette }) => ({
          display: { lg: "none", xs: "flex" },
          borderBottom: `1px solid ${palette.divider}`,
        })}
      >
        <Toolbar sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <Stack direction="row" gap={{ xs: 1, sm: 3 }}>
            <IconButton
              size="medium"
              edge="start"
              sx={{ color: "text.secondary" }}
              onClick={onMenuToggle}
            >
              <MenuRounded />
            </IconButton>
          </Stack>

          {accountMenu}
        </Toolbar>
      </AppBar>
      {/* Распорка под fixed-шапку, чтобы контент не уезжал под неё */}
      <Toolbar sx={{ display: { lg: "none" } }} />
    </>
  );
};
